import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';

const TabPanel = props => {
  const { children, disableWrapper, value, index, ...other } = props;

  return (
    <Box component="div" role="tabpanel" hidden={value !== index} {...other}>
      {value === index && !disableWrapper && <Box p={3}>{children}</Box>}
      {value === index && disableWrapper && children}
    </Box>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  index: PropTypes.any.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any.isRequired,
  disableWrapper: PropTypes.bool
};

TabPanel.defaultProps = {
  disableWrapper: false
};

export default TabPanel;
